/**
 * NCC: collection and search pagination without a page load (loaded by snippets/product-grid.liquid).
 *
 * Horizon's page links were plain navigations, so every page change reloaded the document and landed at the very
 * top of the page (Miles, 2026-09-15: "not sure if this is the best idea"). The links now re-render the results
 * section in place through the Filters block's facets form (the same path a facet tick takes: pushState, section
 * render, the product-grid view transition) and glide the results back under the header, so the first products of
 * the new page are in view and the rest of the page stays where it was. Without a facets form (no Filters block)
 * the links keep working as links.
 */
import { getScrollTop, scrollTo } from '@theme/scroll-container';

const OFFSET_BELOW_HEADER = 24; // the sidebar's resting offset (assets/ncc-theme.css)

document.addEventListener('click', (event) => {
  if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
    return;
  }
  const link = event.target instanceof Element ? event.target.closest('.product-grid-container .pagination__link[href]') : null;
  if (!(link instanceof HTMLAnchorElement)) return;

  const forms = [...document.querySelectorAll('facets-form-component')];
  const form = /** @type {any} */ (forms.find((element) => !element.closest('#filters-drawer')) ?? forms[0]);
  if (!form || typeof form.updateFiltersByURL !== 'function') return;

  event.preventDefault();
  form.updateFiltersByURL(link.pathname + link.search);

  const container = link.closest('.product-grid-container');
  if (!(container instanceof HTMLElement)) return;
  const header = parseFloat(getComputedStyle(container).getPropertyValue('--header-group-height')) || 0;
  const top = container.getBoundingClientRect().top - header - OFFSET_BELOW_HEADER;
  if (top < 0) scrollTo({ top: getScrollTop() + top, behavior: 'smooth' });
});
